import React, { useContext } from 'react';
import { Link, useLocation } from 'wouter';
import {
  FiActivity, FiArchive, FiBarChart2, FiFileText, FiGrid,
  FiLayers, FiLogOut, FiMail, FiMonitor, FiPackage, FiSettings, FiUser,
  FiTrash2, FiTrendingDown, FiTrendingUp, FiUsers, FiX,
} from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationContext';
import { SidebarContext } from '../App';
import { PAGE_ROLES, ROLE_LABELS } from '../config/accessControl';

export default function Sidebar() {
  const { user, logoutUser } = useAuth();
  const { pendingRequests, pendingStockIn, pendingItemRequests, pendingAssetNumbers } = useNotifications();
  const { sidebarOpen, setSidebarOpen } = useContext(SidebarContext);
  const [location, navigate] = useLocation();
  const visibleRole = ROLE_LABELS[user?.role] || user?.role;
  const homePath = user?.role === 'tuzilma_operatori' ? '/departments' : '/dashboard';

  const sections = [
    { title: 'Hisob', items: [
      { path: '/dashboard', icon: <FiGrid />, label: 'Boshqaruv paneli', roles: PAGE_ROLES.dashboard },
      { path: '/items', icon: <FiPackage />, label: 'Mahsulot katalogi', roles: PAGE_ROLES.items },
      { path: '/balance', icon: <FiArchive />, label: 'Ombor qoldig‘i', roles: PAGE_ROLES.balance },
    ]},
    { title: 'Ombor jarayonlari', items: [
      { path: '/stock-in', icon: <FiTrendingUp />, label: 'Kirim hujjatlari', badge: pendingStockIn, roles: PAGE_ROLES.stockIn },
      { path: '/stock-out', icon: <FiTrendingDown />, label: 'Chiqim hujjatlari', roles: PAGE_ROLES.stockOut },
      { path: '/requests', icon: <FiFileText />, label: 'So‘rovlar', badge: pendingRequests, roles: PAGE_ROLES.requests },
      { path: '/item-requests', icon: <FiMail />, label: 'Yangi tovar xatlari', badge: pendingItemRequests, roles: PAGE_ROLES.itemRequests },
      { path: '/assets', icon: <FiMonitor />, label: user?.role === 'buxgalter' ? 'Inventar raqamlash' : 'Inventar aktivlar', badge: pendingAssetNumbers, roles: PAGE_ROLES.assets },
      { path: '/asset-writeoffs', icon: <FiTrash2 />, label: 'Hisobdan chiqarish', roles: PAGE_ROLES.assetWriteoffs },
      { path: '/retired-assets', icon: <FiArchive />, label: 'Hisobdan chiqarilganlar', roles: PAGE_ROLES.retiredAssets },
    ]},
    { title: 'Nazorat', items: [
      { path: '/monitoring', icon: <FiActivity />, label: 'Monitoring', roles: PAGE_ROLES.monitoring },
      { path: '/reports', icon: <FiBarChart2 />, label: 'Hisobotlar', roles: PAGE_ROLES.reports },
      { path: '/users', icon: <FiUsers />, label: 'Foydalanuvchilar', roles: PAGE_ROLES.users },
      { path: '/departments', icon: <FiLayers />, label: 'Tashkiliy tuzilma', roles: PAGE_ROLES.departments },
      { path: '/settings', icon: <FiSettings />, label: 'Sozlamalar', roles: PAGE_ROLES.settings },
    ]},
    { title: 'Akkaunt', items: [
      { path: '/profile', icon: <FiUser />, label: 'Mening profilim', roles: PAGE_ROLES.profile },
    ]},
  ];

  const logout = () => { logoutUser(); navigate('/login'); };

  return <aside className={`sidebar institutional-sidebar${sidebarOpen ? ' sidebar-open' : ''}`}>
    <header className="sidebar-brand">
      <Link href={homePath} className="sidebar-brand__home" onClick={() => setSidebarOpen(false)} aria-label="Bosh sahifaga o‘tish">
        <img className="sidebar-brand__logo" src="/TKTI logo.png" alt="TKTI logosi" />
        <div><strong>TKTI Ombor</strong><span>Moddiy resurslar tizimi</span></div>
      </Link>
      <button className="hamburger-btn sidebar-close" onClick={() => setSidebarOpen(false)} aria-label="Menyuni yopish"><FiX /></button>
    </header>

    <nav className="sidebar-nav">
      {sections.map((section) => {
        const allowed = section.items.filter((item) => item.roles.includes(user?.role));
        if (!allowed.length) return null;
        return <section key={section.title}><h2>{section.title}</h2>{allowed.map((item) => {
          const active = location === item.path;
          return <Link key={item.path} href={item.path} onClick={() => setSidebarOpen(false)} className={`sidebar-link${active ? ' sidebar-link--active' : ''}`}>
            <span className="sidebar-link__icon">{item.icon}</span><span>{item.label}</span>
            {item.badge > 0 && <b>{item.badge > 99 ? '99+' : item.badge}</b>}
          </Link>;
        })}</section>;
      })}
    </nav>

    <footer className="sidebar-user">
      <div className="sidebar-user__avatar">{user?.full_name?.charAt(0)?.toUpperCase()}</div>
      <div><strong>{user?.full_name}</strong><span>{visibleRole}</span></div>
      <button onClick={logout} title="Tizimdan chiqish" aria-label="Tizimdan chiqish"><FiLogOut /></button>
    </footer>
  </aside>;
}
